import { CreditCardChipOutlineIcon } from './CreditCardChipOutlineIcon';

/**
 * author: Jeff Anders
 * id DF35C024-A010-482D-8B28-D567A1C9389D
 * name credit-card-chip-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-chip-outline.svg
 * tags
 * - Banking 
 */
export const CreditCardIccChipOutlineIcon = CreditCardChipOutlineIcon;
export default CreditCardIccChipOutlineIcon